<h3>Gasanlage</h3>
<div *ngIf="actions.length > 0">
  <section *ngFor="let item of actions; first as isFirst; last as isLast">
    <div>
      <app-value-with-label
        *ngIf="item.actionType"
        [label]="'Art der Installation:'"
        [value]="item.actionType | actionTypePipe : 'gas' : 'displayName'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="item.regulatorAlreadyExits"
        [label]="'Regler vorhanden:'"
        [value]="item.regulatorAlreadyExits | jaNeinPipe"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="item.meterNumber"
        [label]="'Zähler-Nr:'"
        [value]="item.meterNumber"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="item.connectionPower"
        [label]="'Zählergröße:'"
        [value]="item.connectionPower"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="showSealingOption && item.sealingNecessary"
        [label]="'Gaszähler muss verplombt werden:'"
        [value]="item.sealingNecessary | jaNeinPipe"></app-value-with-label>
    </div>
    <section>
      <app-gas-devices-summary [devices]="item.devices"></app-gas-devices-summary>
    </section>
  </section>
</div>
